import React, { useState } from 'react'
import Sidebar from './Sidebar'
import { HiHome } from "react-icons/hi2";

import Navbar from './Navbar';
import './AdminLayout.css';
import { FaSlash } from 'react-icons/fa';
import { MdHomeFilled } from 'react-icons/md';

const Adminlayout = ({ children }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const [OpenPage, setOpenPage] = useState("Dashboard");
    const [OpenSubPage, setOpenSubPage] = useState("");

    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    return (
        <section className='adminlayout-container'>
            <div className='adminlayout-navbar-wrapper'>
                <Navbar
                    setOpenPage={setOpenPage}
                    isSidebarVisible={isSidebarVisible}
                    setOpenSubPage={setOpenSubPage}
                    isCollapsed={isSidebarCollapsed}
                    toggleSidebar={toggleSidebar}
                    setIsCollapsed={setIsSidebarCollapsed}
                    title={OpenPage}
                    SubPage={OpenSubPage}
                />
            </div>

            <div className='adminlayout-container-2'>
                <div className={`adminlayout-sidebar-wrapper ${!isSidebarVisible ? 'hidden' : ''}`}>
                    <Sidebar
                        isCollapsed={isSidebarCollapsed}
                        setIsCollapsed={setIsSidebarCollapsed}
                        isVisible={isSidebarVisible}
                    />
                </div>

                <div className='adminlayout-main-wrapper'>
                    <div className='paths-admin'>
                        <MdHomeFilled  /> /
 <p> Dashbaord</p>

                    </div>
                    <div className='adminlayout-content'>
                        {children}
                    </div>
                    
                    <div className='adminlayout-footer'>
                        <div className='adminlayout-footer-text'>
                            Designed and Developed by Acetians Technologies Private Limited | © 2026 All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Adminlayout